import React, { useState } from 'react';
import CustomSwitch from '../../../../../shared/CustomSwitch/CustomSwitch';
import CustomCheckbox from '../../../../../shared/CustomCheckbox/CustomCheckbox';

const transactions = [
  {
    year: 2024,
    entries: [
      {
        date: 'MAR 01',
        invoiceDateApplied: 'MAR 10',
        amount: 563.77,
        status: 'Applied',
      },
      {
        date: 'JAN 15',
        invoiceDateApplied: 'FEB 10',
        amount: 5224.77,
        status: 'Applied',
      },
    ],
  },
  {
    year: 2023,
    entries: [
      {
        date: 'DEC 14',
        invoiceDateApplied: 'DEC 10',
        amount: 5110.44,
        status: 'Applied',
      },
      {
        date: 'NOV 17',
        invoiceDateApplied: 'NOV 10',
        amount: 5268.15,
        status: 'Applied',
      },
    ],
  },
];

export default function Payments({ checked, onChange, hidden }) {
  return (
    <div
      className={`sub-card ${hidden ? 'card-disabled' : ''}`}
      id="invoice-payments"
      style={{
        opacity: hidden ? 0.5 : 1, // dim when hidden
        transition: 'opacity 0.3s', // smooth transition
      }}
    >
      <div className="garden-wall-card-header">
        <h4 className="card-title">Payments</h4>
        <CustomSwitch
          checked={checked} // from parent
          onChange={onChange} // from parent
          size="small" // small | medium | large
          color="var(--primary-color)"
        />
      </div>
      <div className="sc-table">
        <div className="sc-table-head">
          <div className="sc-table-head-cell" style={{ maxWidth: 40 }}></div>
          <div className="sc-table-head-cell" style={{ maxWidth: 100 }}>
            Date
          </div>
          <div className="sc-table-head-cell">Invoice date applied</div>
          <div className="sc-table-head-cell">Amount</div>
          <div className="sc-table-head-cell" style={{ maxWidth: 100 }}>
            Status
          </div>
        </div>
        <div className="sc-table-body">
          {transactions.map((tr) => (
            <div key={tr.year}>
              <div className="table-sc-year" style={{ margin: '8px 0' }}>
                {tr.year}
              </div>
              {tr.entries.map((item, index) => (
                <div
                  className="sc-table-row"
                  key={`${tr.year}-${item.date}-${index}`}
                >
                  <div className="sc-table-th-cell" style={{ maxWidth: 40 }}>
                    <CustomCheckbox checked={false} onChange={() => {}} />
                  </div>
                  <div className="sc-table-th-cell" style={{ maxWidth: 100 }}>
                    {item.date}
                  </div>
                  <div className="sc-table-th-cell">
                    {item.invoiceDateApplied}
                  </div>
                  <div className="sc-table-th-cell">{item.amount}</div>
                  <div className="sc-table-th-cell" style={{ maxWidth: 100 }}>
                    {item.status}
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
